module.exports = __webpack_public_path__ + "static/media/koryu_00037.41663a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/koryu_00037.png
// module id = 75
// module chunks = 0